import React__default from 'react';
import { a as LabelTypography, b as LabelColors, L as Label } from '../index-6420013c.js';
import 'prop-types';
import '../stringSet-b60e9529.js';
var PlaybackTime = function PlaybackTime(_ref) {
  var className = _ref.className,
    _ref$time = _ref.time,
    time = _ref$time === void 0 ? 0 : _ref$time,
    _ref$labelType = _ref.labelType,
    labelType = _ref$labelType === void 0 ? LabelTypography.CAPTION_2 : _ref$labelType,
    _ref$labelColor = _ref.labelColor,
    labelColor = _ref$labelColor === void 0 ? LabelColors.ONCONTENT_1 : _ref$labelColor;
  var naturalTime = time < 0 ? 0 : time;
  var hour = Math.floor(naturalTime / 3600000);
  var min = Math.floor(naturalTime % 3600000 / 60000);
  var sec = Math.floor(naturalTime % 3600000 % 60000 / 1000);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-ui-play-time ".concat(className)
  }, /*#__PURE__*/React__default.createElement(Label, {
    type: labelType,
    color: labelColor
  }, "".concat(hour ? hour + ':' : '').concat(min < 10 ? '0' : '').concat(min ? min : '0', ":").concat(sec < 10 ? '0' : '').concat(sec)));
};
export { PlaybackTime, PlaybackTime as default };